import { type ISmartCallFlowAction } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type.ts'
import {
  AddButtonStore,
  CallEndsStore,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions'

export const isEmptyActions = (
  id: string,
  getActionById: (id: string) => ISmartCallFlowAction | undefined
): boolean => {
  const action = getActionById(id)
  if (!action) return true
  if (action instanceof CallEndsStore) {
    const nextAction = getActionById(action.actionStore.nextIds[0])
    return nextAction instanceof AddButtonStore
  }
  return false
}
